import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { memo, useEffect, useState } from "react";
import styles from './PriceBlock.module.scss';
import { useShelvingStore, useStoreSystem, useStoreRoom } from "../../../store";
import shallow from "zustand/shallow";
import { allPrices, usePrice } from "../../../hooks";
import { getItemsCost } from "../../../utils/calculation";

export const PriceBlock = memo(() => {
    const { itemsGroup } = useStoreSystem(
        (state) => ({
            itemsGroup: state.itemsGroup,
        }),
        shallow
    );

    const { beamsFront, beamsBack, beamsLeft, beamsRight, sectionsFront, sectionsBack, sectionsLeft, sectionsRight } =
        useShelvingStore(
            (state) => ({
                beamsFront: state.shelving.front.beams,
                beamsBack: state.shelving.back.beams,
                beamsLeft: state.shelving.left.beams,
                beamsRight: state.shelving.right.beams,
                sectionsFront: state.shelving.front.sections,
                sectionsBack: state.shelving.back.sections,
                sectionsLeft: state.shelving.left.sections,
                sectionsRight: state.shelving.right.sections,
            }),
            shallow
        );

    // Добавляем отслеживание tireRacks
    const { tireRacks } = useStoreRoom(
        (state) => ({
            tireRacks: state.tireRacks,
        }),
        shallow
    );

    const { totalPrice, oldTotalPrice } = usePrice();
    const theme = useTheme();
    const matchesXL = useMediaQuery(theme.breakpoints.up("xl"));

    const [itemsTotalCost, setTotalCost] = useState<number>(0);

    useEffect(() => {
        setTotalCost(getItemsCost());
    }, [
        itemsGroup,
        beamsFront,
        beamsBack,
        beamsLeft,
        beamsRight,
        sectionsFront,
        sectionsBack,
        sectionsLeft,
        sectionsRight,
        tireRacks, // Добавляем tireRacks в зависимости
    ]);

    useEffect(() => {
        allPrices.totalPrice = totalPrice + itemsTotalCost;
    }, [totalPrice, itemsTotalCost]);

    return (
        <Paper
            sx={{
                height: "100%",
                width: "306px",
                minWidth: "306px",
                marginLeft: "auto",
                boxShadow: "0px 8px 16px 0px rgba(17, 17, 17, 0.35)",
            }}
            elevation={8}
        >
            <Stack direction={"row"} height={"100%"} justifyContent="center" alignItems={"center"}>
                <Box component={"div"} width="50%" pl={3} pr={1}>
                    <Typography fontSize={14} color="text.secondary">
                        ОБЩАЯ
                    </Typography>
                    <Typography fontSize={14} color="text.secondary">
                        СТОИМОСТЬ
                    </Typography>
                </Box>
                <Box component={"div"} width="50%" pr={3} pl={1}>
                    {oldTotalPrice !== totalPrice && (
                        <Typography className={styles.oldPrice}>{oldTotalPrice}₽</Typography>
                    )}
                    <Typography className={styles.price}>{totalPrice + itemsTotalCost}₽</Typography>
                </Box>
            </Stack>
        </Paper>
    );
});
